module.exports = {"pageTitleText":"前台配置","bulletinTitleText":"系統公告 / User Guide 連結","isShowBulletinBoard":"於首頁顯示","userGuideText":"User Guide URL","sendMailToAdmin":"Email","bulletin":"公告內容"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-TW/frontends.json
// module id = EwWA
// module chunks = 3